import { useEffect, useState } from "react";
import Button from "../../../../components/common/button";
import Table from "../../../../components/common/table";
import { useDispatch, useSelector } from "react-redux";
import { resetText } from "../../../../store/slices/textSlice";
import colors from "../../../../share/constants/constants";
import { message } from "antd";
import { fetchPrices } from "../../../../store/slices/priceSlice";
import HandlePriceModal from "./HandlePriceModal";
import View from "../../../../assets/icons/view.svg";
import Trash from "../../../../assets/icons/trash.svg";
import DeleteMemberModal from "../../../../components/common/modalMember";
import { updatePrice } from "../../../../api/payment";

const ManagePrices = () => {
  const dispatch = useDispatch();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const prices = useSelector((state) => state.price);

  const columns = [
    {
      title: "Monthly Subscriptions ($)",
      className: "column-price",
      render: (text) => <>${text || `${199} (default)`}</>,
      dataIndex: "price",
      key: "price",
    },
    {
      title: "Description",
      className: "column-description",
      render: (text) => (
        <>{text || <span className="text-grey">No description</span>}</>
      ),
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <div className="flex space-x-2 w-[100px]">
          <div
            onClick={() => showModal(record)}
            className="w-4 m-auto grid justify-center h-4 pt-1 rounded-full bg-lightLavender cursor-pointer"
          >
            <img src={View} alt="View" />
          </div>
          <div
            className="flex items-center justify-center w-4 h-4  rounded-full bg-lightLavender cursor-pointer"
            onClick={() => handleDeletePrice(record)}
          >
            <img src={Trash} alt="View" />
          </div>
        </div>
      ),
    },
  ];

  const hideModal = () => {
    setIsModalOpen(false);
    setIsDeleteModalOpen(false);
  };

  const showModal = (record) => {
    if (record.id) {
      setIsModalOpen(record);
    } else {
      setIsModalOpen(true);
    }
  };

  const handleDeletePrice = (record) => {
    setIsDeleteModalOpen(record);
  };

  const YesClickHandler = async () => {
    const res = await updatePrice(isDeleteModalOpen?.id, {
      active: false,
    });
    if (res) {
      message.success("Subscription archived successfully");
      dispatch(fetchPrices());
      hideModal();
    }
  };

  const onHandlePriceModalOk = async () => {
    dispatch(fetchPrices());
    hideModal();
  }

  useEffect(() => {
    dispatch(resetText());
  }, []);

  useEffect(() => {
    dispatch(fetchPrices());
  }, []);

  return (
    <div className="grid gap-2 w-full">
      <div className="flex justify-between">
        <div className="flex pt-3 pl-1">
          <div className="flex items-center">
            <span className="text-lg font-bold text-black ml-1">
              Subscriptions
            </span>
          </div>
        </div>
        <div className="mt-2 mr-2">
          <Button
            title="Add Subscription"
            className="w-15.8 h-3.8 br"
            borderRadius={5}
            onClick={showModal}
            color={colors.primaryPurple}
          />
        </div>
      </div>

      <div>
        <div>
          <div className="min-h-screen flex items-start justify-start pt-0">
            <Table
              columns={columns}
              data={prices?.value}
              loading={prices?.isLoading}
            />
          </div>
        </div>
      </div>

      {isModalOpen && (
        <HandlePriceModal
          onCancel={hideModal}
          onOk={onHandlePriceModalOk}
          data={isModalOpen}
          getPrices={() => dispatch(fetchPrices())}
        />
      )}

      {isDeleteModalOpen && (
        <DeleteMemberModal
          title="Archive Subscription"
          text="Are you sure you want to archive this subscription?"
          onCancel={hideModal}
          onOk={YesClickHandler}
        />
      )}
    </div>
  );
};

export default ManagePrices;
